export const DOWNLOAD_PROCESS_STATEMENT_PDF_FAILURE = 'DOWNLOAD_PROCESS_STATEMENT_PDF_FAILURE';

export const downloadProcessStatementPdfFileFailure = error => ({
    type: DOWNLOAD_PROCESS_STATEMENT_PDF_FAILURE,
    payload: error,
    error: true,
});
